<div *ngIf="loading" class="text-center py-4"><div class="spinner-border text-primary"></div></div>

<div *ngIf="!loading" class="row g-3">
  <div class="col-xl-7">
    <div class="card mb-0">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Sağlayıcı</label>
            <select class="form-select" [(ngModel)]="providerType" (ngModelChange)="onProviderChanged()">
              <option *ngFor="let p of providers" [ngValue]="p">{{ providerLabels[p] }}</option>
            </select>
          </div>
          <div class="col-md-6 d-flex align-items-end gap-4">
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" type="checkbox" id="pos-setting-active" [(ngModel)]="form.isActive">
              <label class="form-check-label" for="pos-setting-active">Aktif</label>
            </div>
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" type="checkbox" id="pos-setting-test" [(ngModel)]="form.isTestMode">
              <label class="form-check-label" for="pos-setting-test">Test ortamı</label>
            </div>
          </div>

          <div class="col-md-6" *ngIf="providerType === ProviderType.PavoUniCloud">
            <label class="form-label">
              Üye iş yeri kimliği (MerchantUid) <span class="text-danger" *ngIf="form.isActive">*</span>
              <i class="bx bx-info-circle text-muted" container="body"
                 ngbTooltip="Pavo'nun firmanıza verdiği üye iş yeri kimliği. Farklı vergi numaralı şubedeki cihazda cihaz kartında ayrıca girilebilir."></i>
            </label>
            <input class="form-control font-monospace" [(ngModel)]="form.merchantUid" maxlength="100">
          </div>
          <div class="col-md-6">
            <label class="form-label">
              Müşterisiz satış limiti (₺)
              <i class="bx bx-info-circle text-muted" container="body"
                 ngbTooltip="Bu tutarın üzerindeki kart satışında belge müşteri kimliğiyle düzenlenir; müşteri seçilmeden cihaza gönderilemez."></i>
            </label>
            <input type="number" class="form-control" min="1" step="0.01" [(ngModel)]="form.anonymousSaleLimit">
          </div>

          <div class="col-12">
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="pos-setting-cash" [(ngModel)]="form.sendCashToDevice">
              <label class="form-check-label" for="pos-setting-cash">Nakit ödemeleri de cihaza gönder</label>
            </div>
            <div class="form-text">
              Açıksa hızlı satışta nakit tahsilat da cihazdan belgelenir; kart ve nakit aynı belgede iki ödeme
              olarak gider. Şubede eşleştirilmiş cihaz varken nakit, cihazdan belgelenmeden satış tamamlanamaz.
            </div>
          </div>

          <div class="col-12">
            <label class="form-label">Varsayılan belge satırları</label>
            <div class="btn-group w-100">
              <button type="button" class="btn btn-sm" *ngFor="let mode of lineModes"
                      [ngClass]="+form.defaultLineMode === mode ? 'btn-primary' : 'btn-outline-primary'"
                      (click)="form.defaultLineMode = mode">
                {{ lineModeLabels[mode] }}
              </button>
            </div>
            <div class="form-text">
              <b>Gerçek ürünler:</b> satılan ürünler, has ve işçilik e-faturadaki gibi.
              <b>Emtia kuralları:</b> emtia, miktar ve fiyat e-fatura emtia kurallarıyla otomatik belirlenir
              (<a routerLink="/accounting/bank-commodity-rules">Emtia Kuralları</a>).
              Kasiyer gönderirken değiştirebilir.
            </div>
          </div>
        </div>

        <!-- Entegratör kimliği -->
        <div class="border rounded p-3 mt-3">
          <div class="d-flex align-items-center gap-2 mb-2">
            <b class="small text-uppercase text-muted">Entegratör kimliği</b>
            <span class="badge bg-soft-success text-success" *ngIf="view?.hasIntegratorCredentials && !hasOwnCredentials">
              Uygulama ayarı kullanılıyor
            </span>
            <span class="badge bg-soft-primary text-primary" *ngIf="hasOwnCredentials">Firmaya özel anahtar</span>
            <span class="badge bg-soft-danger text-danger" *ngIf="!view?.hasIntegratorCredentials && !hasOwnCredentials">
              Tanımlı değil
            </span>
          </div>
          <div class="small text-muted mb-2">
            Normalde boş bırakılır: yazılımın entegratör kimliği uygulama ayarındadır. Yalnızca firmanın kendi
            Pavo entegratör hesabı varsa girin. Boş bırakılan alan kayıtlı anahtarı korur.
          </div>
          <div class="row g-2">
            <div class="col-md-6">
              <label class="form-label small mb-1">AppToken</label>
              <input class="form-control font-monospace" type="password" autocomplete="new-password"
                     [(ngModel)]="form.appToken" [placeholder]="view?.appTokenMasked || 'Uygulama ayarı'">
            </div>
            <div class="col-md-6">
              <label class="form-label small mb-1">ApiKey</label>
              <input class="form-control font-monospace" type="password" autocomplete="new-password"
                     [(ngModel)]="form.apiKey" [placeholder]="view?.apiKeyMasked || 'Uygulama ayarı'">
            </div>
          </div>
          <button class="btn btn-sm btn-link text-danger px-0 mt-1" *ngIf="hasOwnCredentials" (click)="clearOwnCredentials()">
            Firmaya özel anahtarları sil
          </button>
        </div>

        <div class="d-flex flex-wrap align-items-center gap-2 mt-3">
          <button class="btn btn-outline-primary" (click)="test()" [disabled]="testing || !view?.isConfigured"
                  ngbTooltip="Kayıtlı ayarla sağlayıcıya bağlanır; cihaza dokunmaz." container="body">
            <span class="spinner-border spinner-border-sm me-1" *ngIf="testing"></span>
            <i class="bx bx-plug me-1" *ngIf="!testing"></i>Bağlantıyı Dene
          </button>
          <span *ngIf="testResult" class="small" [ngClass]="testResult.isSuccess ? 'text-success' : 'text-danger'">
            <i class="bx" [ngClass]="testResult.isSuccess ? 'bx-check-circle' : 'bx-error'"></i> {{ testResult.message }}
          </span>
          <button class="btn btn-primary ms-auto" (click)="save()" [disabled]="saving">
            <span class="spinner-border spinner-border-sm me-1" *ngIf="saving"></span>Kaydet
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pavo'ya özgü ayarlar -->
  <div class="col-xl-5" *ngIf="providerType === ProviderType.PavoUniCloud">
    <div class="card mb-0">
      <div class="card-body">
        <h6 class="mb-1">KDV grubu eşlemesi</h6>
        <div class="small text-muted mb-2">
          Belge satırının KDV oranı / gerekçesi cihazdaki vergi grubuna çevrilir. Boş alan Pavo varsayılanını kullanır.
        </div>
        <table class="table table-sm align-middle mb-3">
          <tbody>
            <tr *ngFor="let group of taxGroupDefaults">
              <td class="small">{{ group.label }}</td>
              <td style="width: 55%">
                <input class="form-control form-control-sm font-monospace" [(ngModel)]="taxGroups[group.key]"
                       (ngModelChange)="syncConfigJson()" [placeholder]="group.value" maxlength="20">
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label small mb-1">
              Kart ödeme aracı (Mediator)
              <i class="bx bx-info-circle text-muted" container="body"
                 ngbTooltip="Genel kart ödemesi için Pavo aracı kodu; boşsa 2. Bankaya özel kod kasa (POS ayarı) üzerinde girilir."></i>
            </label>
            <input type="number" class="form-control form-control-sm" min="1" step="1" placeholder="2"
                   [(ngModel)]="config.cardMediator" (ngModelChange)="syncConfigJson()">
          </div>
          <div class="col-md-6 d-flex align-items-end">
            <div class="form-check mb-1">
              <input class="form-check-input" type="checkbox" id="pos-use-jewellery"
                     [ngModel]="config.useJewellerySale !== false" (ngModelChange)="setUseJewellerySale($event)">
              <label class="form-check-label small" for="pos-use-jewellery">
                Tek kuyum satırında Kuyumcu Satışı
                <i class="bx bx-info-circle text-muted" container="body"
                   ngbTooltip="Belgede tek altın/gümüş satırı varsa Pavo'nun Kuyumcu Satışı türü kullanılır; birden çok kalemde has ve işçilik ayrı satır gider."></i>
              </label>
            </div>
          </div>
        </div>

        <button class="btn btn-sm btn-link px-0 mt-2" (click)="showAdvanced = !showAdvanced">
          <i class="bx" [ngClass]="showAdvanced ? 'bx-chevron-up' : 'bx-chevron-down'"></i> Gelişmiş (JSON)
        </button>
        <div *ngIf="showAdvanced">
          <textarea class="form-control form-control-sm font-monospace" rows="8" [(ngModel)]="configJson"
                    (change)="onConfigJsonEdited()" placeholder="{}"></textarea>
          <div class="form-text" [class.text-danger]="configJsonError">
            {{ configJsonError || 'Yalnızca varsayılandan farklı alanlar. Diğer alanlar: refererApp, applicationName, displayLayout, pushNow, sendTargetSerialNo (açılırsa Pavo reddeder), cardReadTimeoutSeconds, receipt.' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
